import React from "react";

const TopSection = ({ children }) => {
  return <div className="py-28 md:py-36 space-y-10">{children}</div>;
};

export default TopSection;
